(() => {
  document.querySelectorAll('[data-fh-finder]').forEach((finder) => {
    const result = finder.querySelector('[data-fh-result]');
    const resultLink = finder.querySelector('[data-fh-result-link]');
    const image = finder.querySelector('[data-fh-finder-image]');
    const buttons = finder.querySelectorAll('[data-fh-result-text]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((option) => option.classList.remove('is-active'));
        button.classList.add('is-active');

        if (result) {
          result.textContent = button.getAttribute('data-fh-result-text') || '';
        }

        if (resultLink) {
          const url = button.dataset.fhResultUrl || '';
          if (url) {
            resultLink.href = url;
            resultLink.textContent = button.dataset.fhResultLabel || 'Produkt entdecken';
            resultLink.hidden = false;
          } else {
            resultLink.hidden = true;
            resultLink.removeAttribute('href');
          }
        }

        if (image && button.dataset.fhImageSrc) {
          image.classList.add('is-switching');
          window.setTimeout(() => {
            image.src = button.dataset.fhImageSrc;
            image.removeAttribute('srcset');
            image.alt = button.dataset.fhImageAlt || '';
            image.classList.remove('is-switching');
          }, 120);
        }
      });
    });
  });
})();
